// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SubscriptionArticleListResultModel from '../../model/subscription-article-list-result-model';
import SubscriptionArticleListResultDTO from '../dto/subscription-article-list-result-dto';
import dtoSchema from '../schemas/subscription-article-list-result-schema';
import SubscriptionArticleModel from '../../model/subscription-article-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SubscriptionArticleListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SubscriptionArticleListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SubscriptionArticleModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: SubscriptionArticleModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<SubscriptionArticleListResultDTO>): SubscriptionArticleListResultModel;
  static toModel(dto: DeepPartial<SubscriptionArticleListResultDTO> | undefined | null): SubscriptionArticleListResultModel | undefined;
  static toModel(dto: DeepPartial<SubscriptionArticleListResultDTO> | undefined | null): SubscriptionArticleListResultModel | undefined {
    return dto ? new SubscriptionArticleListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SubscriptionArticleListResultModel> | SubscriptionArticleListResultModel): SubscriptionArticleListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as SubscriptionArticleListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SubscriptionArticleListResultModel, can not map to SubscriptionArticleListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
